import { render, staticRenderFns } from "./HumanResourceComponent.vue?vue&type=template&id=f30dbcb4&scoped=true&"
import script from "./HumanResourceComponent.vue?vue&type=script&lang=js&"
export * from "./HumanResourceComponent.vue?vue&type=script&lang=js&"
import style0 from "./HumanResourceComponent.vue?vue&type=style&index=0&id=f30dbcb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30dbcb4",
  null
  
)

export default component.exports